module.exports = __webpack_public_path__ + "img/yushuzhe.eb3b0b4f.jpg";